export default function preview($rootScope, $timeout) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      entry: '=',
    },
    templateUrl: 'app/components/preview/preview.html',
    link: previewLink,
  }

  return directive

  function previewLink($scope) {
    $scope.now = new Date()
    $rootScope.collapse = false

    $scope.color = function(color) {
      if (color === 'dark') {
        $('.button-light').removeClass('is-active')
        $('.button-dark').addClass('is-active')
        $scope.isDark = !$scope.isDark
      } else {
        $('.button-dark').removeClass('is-active')
        $('.button-light').addClass('is-active')
        $scope.isDark = !$scope.isDark
      }
    }

    $timeout(function() {
      $('[data-toggle=offcanvas]').click(function() {
        $('.row-offcanvas').toggleClass('activee')
        if (!$('.row-offcanvas').hasClass('activee')) {
          $('#sidebaroffcanvas')
            .removeClass('sidebar-offcanvas__hide')
            .addClass('sidebar-offcanvas__show')
          $rootScope.collapse = true
        } else {
          $('#sidebaroffcanvas')
            .addClass('sidebar-offcanvas__hide')
            .removeClass('sidebar-offcanvas__show')
          $rootScope.collapse = false
        }
      })
    }, 150)
  }
}
